import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';
import { ConfigNotificacoes } from '../components/config/ConfigNotificacoes';
import { ConfigSistema } from '../components/config/ConfigSistema';
import { ConfigSenha } from '../components/config/ConfigSenha';
import { PermissoesModal } from '../components/config/PermissoesModal';
import { ProntuariosMigracao } from '../components/config/ProntuariosMigracao';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Separator } from '../components/ui/separator';
import { Switch } from '../components/ui/switch';
import { Badge } from '../components/ui/badge';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { 
  Lock, 
  Loader2, 
  CheckCircle2, 
  AlertCircle,
  Eye,
  EyeOff,
  Settings,
  User,
  Shield,
  Users,
  MapPin,
  Clock,
  Stethoscope,
  Save,
  LocateFixed,
  Plus,
  Pencil,
  Trash2,
  Palette,
  UserPlus,
  Mail,
  Key,
  UserCog,
  Ban,
  CheckCircle,
  Bell,
  Package,
  Home,
  Phone,
  Navigation2,
  BarChart3,
  History,
  RefreshCw
} from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../components/ui/table';
import { toast } from 'sonner';
import { MapPicker } from '../components/ui/map-picker';
import { buscarCEP } from '../lib/utils';
import { apiErrorMessage } from '../lib/apiErrors';

const Configuracoes = () => {
  const { api, user, logout, can } = useAuth();
  
  // Password change state
  const [formData, setFormData] = useState({
    senhaAtual: '',
    novaSenha: '',
    confirmarSenha: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  
  // Show/hide password toggles
  const [showSenhaAtual, setShowSenhaAtual] = useState(false);
  const [showNovaSenha, setShowNovaSenha] = useState(false);
  const [showConfirmarSenha, setShowConfirmarSenha] = useState(false);

  // System settings state
  const [systemSettings, setSystemSettings] = useState({
    capacidade_por_equipe: 7,
    capacidade_total: 0,
    tarefa_automatica_enfermagem: true,
    horario_tarefa_enfermagem: '07:00',
    base_endereco: '',
    base_lat: 0,
    base_lng: 0
  });
  const [settingsLoading, setSettingsLoading] = useState(true);
  const [savingSettings, setSavingSettings] = useState(false);
  const [geocodingBase, setGeocodingBase] = useState(false);

  // Equipes management state
  const [equipes, setEquipes] = useState([]);
  const [loadingEquipes, setLoadingEquipes] = useState(true);
  const [equipeModalOpen, setEquipeModalOpen] = useState(false);
  const [editingEquipe, setEditingEquipe] = useState(null);
  const [equipeForm, setEquipeForm] = useState({ 
    nome: '', capacidade: 7, cor: '#3B82F6',
    tecnico_nome: '', tecnico_telefone: '', tecnico_endereco: '',
    tecnico_cep: '', tecnico_logradouro: '', tecnico_numero: '',
    tecnico_bairro: '', tecnico_cidade: '', tecnico_uf: '',
    tecnico_lat: null, tecnico_lng: null, tecnico_user_id: '',
    ponto_inicial_tipo: 'BASE',
    ponto_final_tipo: 'BASE'
  });
  const [savingEquipe, setSavingEquipe] = useState(false);
  
  // Médicos management state
  const [medicosList, setMedicosList] = useState([]);
  const [medicoModalOpen, setMedicoModalOpen] = useState(false);
  const [editingMedico, setEditingMedico] = useState(null);
  const [medicoForm, setMedicoForm] = useState({ nome: '', unidade_origem: '' });
  const [deletingEquipe, setDeletingEquipe] = useState(null);
  const [tecnicoMapOpen, setTecnicoMapOpen] = useState(false);
  const [geocodingTecnico, setGeocodingTecnico] = useState(false);
  const [tecnicoCepLoading, setTecnicoCepLoading] = useState(false);
  const [tecnicoCepError, setTecnicoCepError] = useState('');

  // Users management state
  const [usuarios, setUsuarios] = useState([]);
  const [loadingUsuarios, setLoadingUsuarios] = useState(true);
  const [usuarioModalOpen, setUsuarioModalOpen] = useState(false);
  const [editingUsuario, setEditingUsuario] = useState(null);
  const [usuarioForm, setUsuarioForm] = useState({ 
    nome: '', 
    email: '', 
    senha: '', 
    perfil: 'enfermeiro' 
  });
  const [savingUsuario, setSavingUsuario] = useState(false);
  const [confirmPerfilChange, setConfirmPerfilChange] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [pendingPerfilChange, setPendingPerfilChange] = useState(null);

  // Notification preferences state
  const [notifPrefs, setNotifPrefs] = useState({
    notificar_estoque_critico: true,
    cooldown_horas: 24,
    notificar_validade_vencida: true,
    notificar_validade_proxima: true
  });
  const [loadingNotifPrefs, setLoadingNotifPrefs] = useState(true);
  const [savingNotifPrefs, setSavingNotifPrefs] = useState(false);

  // Permissions modal state
  const [showPermissoesModal, setShowPermissoesModal] = useState(false);
  const [selectedUserForPermissoes, setSelectedUserForPermissoes] = useState(null);
  
  // Backfill state
  const [backfillPreview, setBackfillPreview] = useState(null);
  const [loadingBackfillPreview, setLoadingBackfillPreview] = useState(false);
  const [showBackfillModal, setShowBackfillModal] = useState(false);
  const [backfillConfirmText, setBackfillConfirmText] = useState('');
  const [executingBackfill, setExecutingBackfill] = useState(false);
  const [backfillResult, setBackfillResult] = useState(null);
  

  // Profile options with descriptions
  const perfilOptions = [
    { value: 'master_admin', label: 'MASTER_ADMIN', description: 'Acesso total ao sistema (superusuário)' },
    { value: 'admin', label: 'ADMIN', description: 'Administrador - gerencia usuários, vê custos e relatórios' },
    { value: 'aux_adm', label: 'Aux. Adm', description: 'Auxiliar administrativo - visualiza Internações e Kanban; poder total em Controle e Recebimento de Guias' },
    { value: 'gestor', label: 'GESTOR', description: 'Gestor - supervisiona equipes e operações (não vê custos)' },
    { value: 'operador', label: 'OPERADOR', description: 'Operador - acesso operacional básico' },
    { value: 'medico', label: 'Médico', description: 'Atendimento médico e prescrições' },
    { value: 'enfermeiro', label: 'Enfermeiro', description: 'Cuidados de enfermagem' },
    { value: 'tecnico', label: 'Técnico', description: 'Apoio técnico' },
    { value: 'recepcionista', label: 'Recepcionista', description: 'Atendimento e cadastros' },
    { value: 'financeiro', label: 'Financeiro', description: 'Acesso a custos e relatórios financeiros' },
    { value: 'controlista_estoque', label: 'Controlista de Estoque', description: 'Acesso completo ao estoque, dispensação e prescrições' },
    { value: 'fisioterapeuta', label: 'Fisioterapeuta', description: 'Acesso ao módulo de Especialidades (Fisioterapia)' },
    { value: 'fonoaudiologo', label: 'Fonoaudiólogo', description: 'Acesso ao módulo de Especialidades (Fonoaudiologia)' },
    { value: 'nutricionista', label: 'Nutricionista', description: 'Acesso ao módulo de Especialidades (Nutrição)' },
    { value: 'psicologo', label: 'Psicólogo', description: 'Acesso ao módulo de Especialidades (Psicologia)' },
  ];

  // Protected email that must remain MASTER_ADMIN
  const PROTECTED_MASTER_ADMIN = 'andrecesarcoelho@gmail.com';

  // Color options for equipes
  const colorOptions = [
    { value: '#3B82F6', name: 'Azul' },
    { value: '#10B981', name: 'Verde' },
    { value: '#F59E0B', name: 'Amarelo' },
    { value: '#EF4444', name: 'Vermelho' },
    { value: '#8B5CF6', name: 'Roxo' },
    { value: '#EC4899', name: 'Rosa' },
    { value: '#14B8A6', name: 'Teal' },
    { value: '#F97316', name: 'Laranja' },
  ];

  // Load system settings
  useEffect(() => {
    if (can('ver_configuracoes')) fetchSettings();
    if (can('gerenciar_equipes')) fetchEquipes();
    if (can('gerenciar_usuarios')) fetchUsuarios();
    fetchNotifPrefs();
    if (can('gerenciar_medicos')) fetchMedicos();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchNotifPrefs = async () => {
    try {
      const response = await api.get('/notificacoes/preferencias');
      setNotifPrefs(response.data);
    } catch (err) {
      console.error('Error fetching notification preferences:', err);
    } finally {
      setLoadingNotifPrefs(false);
    }
  };

  const handleSaveNotifPrefs = async () => {
    setSavingNotifPrefs(true);
    try {
      await api.put('/notificacoes/preferencias', notifPrefs);
      toast.success('Preferências de notificação salvas!');
    } catch (err) {
      toast.error('Erro ao salvar preferências');
    } finally {
      setSavingNotifPrefs(false);
    }
  };

  // Permissions modal functions
  const handleOpenPermissoesModal = (usuario) => {
    setSelectedUserForPermissoes(usuario);
    setShowPermissoesModal(true);
  };

  // Backfill functions
  const fetchBackfillPreview = async () => {
    setLoadingBackfillPreview(true);
    try {
      const response = await api.get('/servicos/backfill/preview');
      setBackfillPreview(response.data);
    } catch (err) {
      toast.error('Erro ao carregar preview do backfill');
      console.error('Error fetching backfill preview:', err);
    } finally {
      setLoadingBackfillPreview(false);
    }
  };

  const handleOpenBackfillModal = async () => {
    await fetchBackfillPreview();
    setShowBackfillModal(true);
    setBackfillConfirmText('');
    setBackfillResult(null);
  };

  const handleExecuteBackfill = async () => {
    if (backfillConfirmText !== 'CONFIRMAR') {
      toast.error('Digite CONFIRMAR para prosseguir');
      return;
    }

    setExecutingBackfill(true);
    try {
      const response = await api.post('/servicos/backfill/executar', {
        confirmacao: 'CONFIRMAR'
      });
      setBackfillResult(response.data);
      toast.success(`Backfill concluído! ${response.data.servicos_criados} serviços criados.`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao executar backfill');
      console.error('Error executing backfill:', err);
    } finally {
      setExecutingBackfill(false);
    }
  };

  const fetchUsuarios = async () => {
    try {
      const response = await api.get('/usuarios');
      setUsuarios(response.data);
    } catch (err) {
      console.error('Error fetching usuarios:', err);
    } finally {
      setLoadingUsuarios(false);
    }
  };

  const fetchEquipes = async () => {
    try {
      const response = await api.get('/equipes');
      setEquipes(response.data.equipes.filter(e => e.id !== 'sem_equipe'));
    } catch (err) {
      console.error('Error fetching equipes:', err);
    } finally {
      setLoadingEquipes(false);
    }
  };

  const fetchMedicos = async () => {
    try {
      const response = await api.get('/medicos');
      setMedicosList(response.data || []);
    } catch (err) {
      console.error('Error fetching medicos:', err);
    }
  };

  const handleSaveMedico = async () => {
    if (!medicoForm.nome.trim()) {
      toast.error('Nome é obrigatório');
      return;
    }
    try {
      if (editingMedico) {
        await api.put(`/medicos/${editingMedico.id}`, medicoForm);
        toast.success('Médico atualizado');
      } else {
        await api.post('/medicos', medicoForm);
        toast.success('Médico criado');
      }
      setMedicoModalOpen(false);
      setEditingMedico(null);
      setMedicoForm({ nome: '', unidade_origem: '' });
      fetchMedicos();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao salvar médico');
    }
  };

  const handleToggleMedicoAtivo = async (medico) => {
    try {
      await api.put(`/medicos/${medico.id}/toggle-ativo`);
      toast.success(`${medico.nome} ${medico.ativo !== false ? 'desativado' : 'reativado'}`);
      fetchMedicos();
    } catch (err) {
      toast.error('Erro ao alterar status');
    }
  };

  const handleDeleteMedico = async (medico) => {
    if (!confirm(`Excluir ${medico.nome}?`)) return;
    try {
      await api.delete(`/medicos/${medico.id}`);
      toast.success('Médico excluído');
      fetchMedicos();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao excluir médico');
    }
  };

  const fetchSettings = async () => {
    try {
      const response = await api.get('/settings');
      setSystemSettings({
        capacidade_por_equipe: response.data.capacidade_por_equipe || 7,
        capacidade_total: response.data.capacidade_total || 0,
        tarefa_automatica_enfermagem: response.data.tarefa_automatica_enfermagem ?? true,
        horario_tarefa_enfermagem: response.data.horario_tarefa_enfermagem || '07:00',
        base_endereco: response.data.base_endereco || '',
        base_lat: response.data.base_lat || 0,
        base_lng: response.data.base_lng || 0
      });
    } catch (err) {
      console.error('Error fetching settings:', err);
    } finally {
      setSettingsLoading(false);
    }
  };

  const handleSaveSettings = async () => {
    setSavingSettings(true);
    try {
      await api.put('/settings', systemSettings);
      toast.success('Configurações salvas com sucesso!');
    } catch (err) {
      toast.error('Erro ao salvar configurações');
      console.error('Error saving settings:', err);
    } finally {
      setSavingSettings(false);
    }
  };

  const handleGeocodeBase = async () => {
    if (!systemSettings.base_endereco) {
      toast.error('Digite o endereço base primeiro');
      return;
    }
    
    setGeocodingBase(true);
    try {
      const response = await api.post('/settings/geocode-base');
      setSystemSettings(prev => ({
        ...prev,
        base_lat: response.data.lat,
        base_lng: response.data.lng,
        base_endereco: response.data.endereco
      }));
      toast.success('Endereço geocodificado com sucesso!');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao geocodificar endereço');
    } finally {
      setGeocodingBase(false);
    }
  };

  // Equipe management functions
  const handleOpenEquipeModal = (equipe = null) => {
    setTecnicoCepError('');
    if (equipe) {
      setEditingEquipe(equipe);
      // Parse address components from stored full address
      const endereco = equipe.tecnico_endereco || '';
      setEquipeForm({
        nome: equipe.nome,
        capacidade: equipe.capacidade,
        cor: equipe.cor || '#3B82F6',
        tecnico_nome: equipe.tecnico_nome || '',
        tecnico_telefone: equipe.tecnico_telefone || '',
        tecnico_endereco: endereco,
        tecnico_cep: equipe.tecnico_cep || '',
        tecnico_logradouro: equipe.tecnico_logradouro || '',
        tecnico_numero: equipe.tecnico_numero || '',
        tecnico_bairro: equipe.tecnico_bairro || '',
        tecnico_cidade: equipe.tecnico_cidade || '',
        tecnico_uf: equipe.tecnico_uf || '',
        tecnico_lat: equipe.tecnico_lat || null,
        tecnico_lng: equipe.tecnico_lng || null,
        tecnico_user_id: equipe.tecnico_user_id || '',
        ponto_inicial_tipo: equipe.ponto_inicial_tipo || 'BASE',
        ponto_final_tipo: equipe.ponto_final_tipo || 'BASE'
      });
    } else {
      setEditingEquipe(null);
      setEquipeForm({ 
        nome: '', capacidade: 7, cor: '#3B82F6',
        tecnico_nome: '', tecnico_telefone: '', tecnico_endereco: '',
        tecnico_cep: '', tecnico_logradouro: '', tecnico_numero: '',
        tecnico_bairro: '', tecnico_cidade: '', tecnico_uf: '',
        tecnico_lat: null, tecnico_lng: null, tecnico_user_id: '',
        ponto_inicial_tipo: 'BASE',
        ponto_final_tipo: 'BASE'
      });
    }
    setEquipeModalOpen(true);
  };

  const handleSaveEquipe = async () => {
    if (!equipeForm.nome.trim()) {
      toast.error('Digite o nome da equipe');
      return;
    }

    // Build full address from components before saving
    const parts = [
      equipeForm.tecnico_logradouro,
      equipeForm.tecnico_numero ? `nº ${equipeForm.tecnico_numero}` : '',
      equipeForm.tecnico_bairro,
      equipeForm.tecnico_cidade,
      equipeForm.tecnico_uf
    ].filter(Boolean);
    const fullAddress = parts.length > 0 ? parts.join(', ') : equipeForm.tecnico_endereco;

    const payload = {
      ...equipeForm,
      tecnico_endereco: fullAddress || equipeForm.tecnico_endereco
    };

    setSavingEquipe(true);
    try {
      if (editingEquipe) {
        await api.put(`/equipes/${editingEquipe.id}`, payload);
        toast.success('Equipe atualizada com sucesso!');
      } else {
        await api.post('/equipes', payload);
        toast.success('Equipe criada com sucesso!');
      }
      setEquipeModalOpen(false);
      fetchEquipes();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao salvar equipe');
    } finally {
      setSavingEquipe(false);
    }
  };

  const handleDeleteEquipe = async (equipeId) => {
    if (!window.confirm('Tem certeza que deseja excluir esta equipe? Os pacientes serão desvinculados.')) {
      return;
    }

    setDeletingEquipe(equipeId);
    try {
      await api.delete(`/equipes/${equipeId}`);
      toast.success('Equipe excluída com sucesso!');
      fetchEquipes();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao excluir equipe');
    } finally {
      setDeletingEquipe(null);
    }
  };

  const handleGeocodeTecnico = async () => {
    // Build full address from components
    const parts = [
      equipeForm.tecnico_logradouro,
      equipeForm.tecnico_numero,
      equipeForm.tecnico_bairro,
      equipeForm.tecnico_cidade,
      equipeForm.tecnico_uf
    ].filter(Boolean);
    const fullAddr = parts.join(', ') || equipeForm.tecnico_endereco;
    if (!fullAddr?.trim()) {
      toast.error('Preencha o endereço do técnico');
      return;
    }
    setGeocodingTecnico(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(fullAddr)}&limit=1`,
        { headers: { 'Accept-Language': 'pt-BR' } }
      );
      const data = await response.json();
      if (data && data.length > 0) {
        setEquipeForm(prev => ({
          ...prev,
          tecnico_lat: parseFloat(data[0].lat),
          tecnico_lng: parseFloat(data[0].lon),
          tecnico_endereco: fullAddr
        }));
        toast.success('Endereço localizado!');
      } else {
        toast.warning('Endereço não encontrado. Use o mapa para definir.');
      }
    } catch {
      toast.error('Erro ao buscar endereço');
    } finally {
      setGeocodingTecnico(false);
    }
  };

  const handleTecnicoCEP = async (cep) => {
    const cleaned = cep.replace(/\D/g, '');
    setEquipeForm(prev => ({ ...prev, tecnico_cep: cep }));
    if (cleaned.length === 8) {
      setTecnicoCepLoading(true);
      setTecnicoCepError('');
      const result = await buscarCEP(cleaned);
      if (result.error) {
        setTecnicoCepError(result.error);
      } else {
        setEquipeForm(prev => ({
          ...prev,
          tecnico_cep: cleaned.replace(/(\d{5})(\d{3})/, '$1-$2'),
          tecnico_logradouro: result.logradouro || prev.tecnico_logradouro,
          tecnico_bairro: result.bairro || prev.tecnico_bairro,
          tecnico_cidade: result.cidade || prev.tecnico_cidade,
          tecnico_uf: result.uf || prev.tecnico_uf,
          tecnico_lat: null, tecnico_lng: null
        }));
        toast.success('Endereço preenchido pelo CEP!');
      }
      setTecnicoCepLoading(false);
    }
  };

  const handleTecnicoMapSelect = (lat, lng, address) => {
    setEquipeForm(prev => ({
      ...prev,
      tecnico_lat: lat,
      tecnico_lng: lng,
      tecnico_endereco: address || prev.tecnico_endereco
    }));
    setTecnicoMapOpen(false);
    toast.success('Localização do técnico definida!');
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    setError('');
    setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    // Validations
    if (!formData.senhaAtual) {
      setError('Digite sua senha atual');
      return;
    }

    if (!formData.novaSenha) {
      setError('Digite a nova senha');
      return;
    }

    if (formData.novaSenha.length < 10 || new TextEncoder().encode(formData.novaSenha).length > 72) {
      setError('A senha deve ter no mínimo 10 caracteres e no máximo 72 bytes');
      return;
    }

    if (formData.novaSenha !== formData.confirmarSenha) {
      setError('Nova senha e confirmação não conferem.');
      return;
    }

    if (formData.senhaAtual === formData.novaSenha) {
      setError('A nova senha deve ser diferente da atual');
      return;
    }

    setLoading(true);

    try {
      await api.post('/auth/change-password', {
        senha_atual: formData.senhaAtual,
        nova_senha: formData.novaSenha,
        confirmar_senha: formData.confirmarSenha
      });
      
      setSuccess(true);
      toast.success('Senha alterada. Faça login novamente com a nova senha.');
      await logout();
      
      // Clear form
      setFormData({
        senhaAtual: '',
        novaSenha: '',
        confirmarSenha: ''
      });
      
    } catch (err) {
      const message = apiErrorMessage(err, 'Não foi possível alterar a senha. Verifique os dados e tente novamente.');
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      senhaAtual: '',
      novaSenha: '',
      confirmarSenha: ''
    });
    setError('');
    setSuccess(false);
  };

  const isAdmin = can('gerenciar_usuarios');
  const canManagePerms = can('gerenciar_permissoes');
  const canManageMedicos = can('gerenciar_medicos');
  const canViewSettings = can('ver_configuracoes');
  const isMasterAdmin = ['MASTER_ADMIN', 'Master Admin', 'master_admin'].includes(user?.perfil);

  const handleOpenUsuarioModal = (usuario = null) => {
    if (usuario) {
      setEditingUsuario(usuario);
      setUsuarioForm({
        nome: usuario.nome,
        email: usuario.email,
        senha: '',
        perfil: usuario.perfil
      });
    } else {
      setEditingUsuario(null);
      setUsuarioForm({ nome: '', email: '', senha: '', perfil: 'enfermeiro' });
    }
    setUsuarioModalOpen(true);
  };

  // Check if changing profile requires confirmation
  const isPerfilChangeRisky = (originalPerfil, newPerfil, email) => {
    const masterProfiles = ['master_admin', 'Master Admin', 'MASTER_ADMIN'];
    const wasMaster = masterProfiles.includes(originalPerfil);
    const willBeMaster = masterProfiles.includes(newPerfil);
    
    // Protected user cannot lose master_admin
    if (email === PROTECTED_MASTER_ADMIN && wasMaster && !willBeMaster) {
      return 'blocked';
    }
    
    // Any change to/from master_admin requires confirmation
    if (wasMaster !== willBeMaster) {
      return 'confirm';
    }
    
    return 'safe';
  };

  // Count current master admins
  const countMasterAdmins = () => {
    return usuarios.filter(u => 
      ['master_admin', 'Master Admin', 'MASTER_ADMIN'].includes(u.perfil)
    ).length;
  };

  const handleSaveUsuario = async () => {
    if (!usuarioForm.nome.trim() || !usuarioForm.email.trim()) {
      toast.error('Nome e email são obrigatórios');
      return;
    }
    
    if (!editingUsuario && !usuarioForm.senha) {
      toast.error('Senha é obrigatória para novo usuário');
      return;
    }
    if (usuarioForm.senha && (usuarioForm.senha.length < 10 || new TextEncoder().encode(usuarioForm.senha).length > 72)) {
      toast.error('A senha deve ter no mínimo 10 caracteres e no máximo 72 bytes');
      return;
    }

    // Check for risky profile changes
    if (editingUsuario && editingUsuario.perfil !== usuarioForm.perfil) {
      const riskLevel = isPerfilChangeRisky(editingUsuario.perfil, usuarioForm.perfil, editingUsuario.email);
      
      if (riskLevel === 'blocked') {
        toast.error('Este usuário não pode perder o perfil Master Admin');
        return;
      }
      
      // Check if removing last master admin
      const masterProfiles = ['master_admin', 'Master Admin', 'MASTER_ADMIN'];
      const wasMaster = masterProfiles.includes(editingUsuario.perfil);
      const willBeMaster = masterProfiles.includes(usuarioForm.perfil);
      
      if (wasMaster && !willBeMaster && countMasterAdmins() <= 1) {
        toast.error('Deve existir pelo menos 1 Master Admin no sistema');
        return;
      }
      
      if (riskLevel === 'confirm' && !confirmPerfilChange) {
        setPendingPerfilChange({ editingUsuario, usuarioForm });
        setConfirmPerfilChange(true);
        setConfirmText('');
        return;
      }
    }

    await executeSaveUsuario();
  };

  const executeSaveUsuario = async () => {
    setSavingUsuario(true);
    try {
      if (editingUsuario) {
        // Update existing user
        const updateData = {
          nome: usuarioForm.nome,
          email: usuarioForm.email,
          perfil: usuarioForm.perfil
        };
        if (usuarioForm.senha) {
          updateData.senha = usuarioForm.senha;
        }
        await api.put(`/usuarios/${editingUsuario.id}`, updateData);
        toast.success('Usuário atualizado com sucesso!');
      } else {
        // Create new user
        await api.post('/usuarios', {
          nome: usuarioForm.nome,
          email: usuarioForm.email,
          senha: usuarioForm.senha,
          perfil: usuarioForm.perfil
        });
        toast.success('Usuário criado com sucesso!');
      }
      setUsuarioModalOpen(false);
      setConfirmPerfilChange(false);
      setConfirmText('');
      setPendingPerfilChange(null);
      fetchUsuarios();
    } catch (err) {
      toast.error(apiErrorMessage(err, 'Erro ao salvar usuário'));
    } finally {
      setSavingUsuario(false);
    }
  };

  const handleConfirmPerfilChange = () => {
    if (confirmText !== 'CONFIRMAR') {
      toast.error('Digite CONFIRMAR para prosseguir');
      return;
    }
    executeSaveUsuario();
  };

  const handleToggleUsuarioAtivo = async (usuario) => {
    // Protect master admin from being deactivated
    if (usuario.email === PROTECTED_MASTER_ADMIN) {
      toast.error('Este usuário não pode ser desativado');
      return;
    }
    
    // Check if deactivating last master admin
    const masterProfiles = ['master_admin', 'Master Admin', 'MASTER_ADMIN'];
    if (masterProfiles.includes(usuario.perfil) && usuario.ativo !== false) {
      if (countMasterAdmins() <= 1) {
        toast.error('Deve existir pelo menos 1 Master Admin ativo no sistema');
        return;
      }
    }
    
    try {
      await api.put(`/usuarios/${usuario.id}`, {
        ...usuario,
        ativo: !usuario.ativo
      });
      toast.success(usuario.ativo ? 'Usuário desativado' : 'Usuário ativado');
      fetchUsuarios();
    } catch (err) {
      toast.error('Erro ao alterar status do usuário');
    }
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="configuracoes-page">
        {/* Header */}
        <div>
          <h1 className="text-3xl font-bold font-['Manrope'] tracking-tight flex items-center gap-3">
            <Settings className="h-8 w-8" />
            Configurações
          </h1>
          <p className="text-muted-foreground mt-1">
            Gerencie suas preferências e configurações do sistema
          </p>
        </div>

        {/* User Info Card */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <User className="h-5 w-5" />
              Informações do Usuário
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <Label className="text-muted-foreground">Nome</Label>
                <p className="font-medium">{user?.nome || '-'}</p>
              </div>
              <div>
                <Label className="text-muted-foreground">E-mail</Label>
                <p className="font-medium">{user?.email || '-'}</p>
              </div>
              <div>
                <Label className="text-muted-foreground">Perfil</Label>
                <p className="font-medium capitalize">{user?.perfil?.replace('_', ' ') || '-'}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Notification Preferences */}
        <ConfigNotificacoes
          notifPrefs={notifPrefs}
          setNotifPrefs={setNotifPrefs}
          loadingNotifPrefs={loadingNotifPrefs}
          savingNotifPrefs={savingNotifPrefs}
          handleSaveNotifPrefs={handleSaveNotifPrefs}
        />

        {/* System Settings */}
        <ConfigSistema
          isAdmin={canViewSettings}
          systemSettings={systemSettings}
          setSystemSettings={setSystemSettings}
          settingsLoading={settingsLoading}
          savingSettings={savingSettings}
          handleSaveSettings={handleSaveSettings}
          geocodingBase={geocodingBase}
          handleGeocodeBase={handleGeocodeBase}
          equipes={equipes}
          loadingEquipes={loadingEquipes}
          deletingEquipe={deletingEquipe}
          handleOpenEquipeModal={handleOpenEquipeModal}
          handleDeleteEquipe={handleDeleteEquipe}
          api={api}
        />

        {/* Numeração histórica de prontuários - Master Admin Only */}
        {isMasterAdmin && <ProntuariosMigracao api={api} />}

        {/* Users Management Card - Master Admin Only */}
        {canManageMedicos && (
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle className="flex items-center gap-2">
                    <Stethoscope className="h-5 w-5" />
                    Gerenciamento de Médicos
                  </CardTitle>
                  <CardDescription>
                    Cadastre e gerencie os médicos disponíveis para atribuição aos pacientes
                  </CardDescription>
                </div>
                <Button
                  onClick={() => { setEditingMedico(null); setMedicoForm({ nome: '', unidade_origem: '' }); setMedicoModalOpen(true); }}
                  className="gap-2"
                  data-testid="btn-adicionar-medico"
                >
                  <Plus className="h-4 w-4" />
                  Adicionar médico
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {medicosList.length === 0 ? (
                <div className="text-center py-6 text-muted-foreground">
                  <Stethoscope className="h-10 w-10 mx-auto mb-2 opacity-50" />
                  <p>Nenhum médico cadastrado</p>
                </div>
              ) : (
                <div className="border rounded-md overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-muted/50">
                      <tr>
                        <th className="text-left p-3 font-medium">Nome</th>
                        <th className="text-center p-3 font-medium">Unidade</th>
                        <th className="text-center p-3 font-medium">Status</th>
                        <th className="text-center p-3 font-medium">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {medicosList.map(m => (
                        <tr key={m.id} className="border-t" data-testid={`medico-row-${m.id}`}>
                          <td className="p-3">
                            <div className="flex items-center gap-2">
                              <Stethoscope className="h-4 w-4 text-blue-500" />
                              <span className="font-medium">{m.nome}</span>
                            </div>
                          </td>
                          <td className="p-3 text-center">
                            {m.unidade_origem ? (
                              <Badge variant="outline" className="text-xs">{m.unidade_origem}</Badge>
                            ) : (
                              <span className="text-xs text-muted-foreground">-</span>
                            )}
                          </td>
                          <td className="p-3 text-center">
                            <Badge className={m.ativo !== false ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-500'}>
                              {m.ativo !== false ? 'Ativo' : 'Inativo'}
                            </Badge>
                          </td>
                          <td className="p-3">
                            <div className="flex justify-center gap-1">
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => { setEditingMedico(m); setMedicoForm({ nome: m.nome, unidade_origem: m.unidade_origem || '' }); setMedicoModalOpen(true); }}
                                title="Editar"
                                data-testid={`btn-edit-medico-${m.id}`}
                              >
                                <Pencil className="h-4 w-4" />
                              </Button>
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => handleToggleMedicoAtivo(m)}
                                title={m.ativo !== false ? 'Desativar' : 'Reativar'}
                                data-testid={`btn-toggle-medico-${m.id}`}
                              >
                                {m.ativo !== false ? <Ban className="h-4 w-4 text-red-500" /> : <CheckCircle className="h-4 w-4 text-green-500" />}
                              </Button>
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => handleDeleteMedico(m)}
                                title="Excluir"
                                data-testid={`btn-delete-medico-${m.id}`}
                              >
                                <Trash2 className="h-4 w-4 text-red-500" />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </CardContent>
          </Card>
        )}

        {/* Médico Modal */}
        <Dialog open={medicoModalOpen} onOpenChange={setMedicoModalOpen}>
          <DialogContent data-testid="dialog-medico">
            <DialogHeader>
              <DialogTitle>{editingMedico ? 'Editar Médico' : 'Adicionar Médico'}</DialogTitle>
              <DialogDescription>
                {editingMedico ? 'Edite o nome do médico' : 'Cadastre um novo médico no sistema'}
              </DialogDescription>
            </DialogHeader>
            <div className="grid gap-4 py-4">
              <div className="space-y-2">
                <Label>Nome *</Label>
                <Input
                  value={medicoForm.nome}
                  onChange={e => setMedicoForm({ ...medicoForm, nome: e.target.value })}
                  placeholder="Ex: Dr. João Silva"
                  data-testid="input-medico-nome"
                />
              </div>
              <div className="space-y-2">
                <Label>Unidade de Origem</Label>
                <Select
                  value={medicoForm.unidade_origem}
                  onValueChange={(v) => setMedicoForm({ ...medicoForm, unidade_origem: v })}
                >
                  <SelectTrigger data-testid="select-medico-unidade">
                    <SelectValue placeholder="Selecione a unidade" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="HGR">HGR</SelectItem>
                    <SelectItem value="PACS">PACS</SelectItem>
                    <SelectItem value="HMI">HMI (Maternidade)</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => setMedicoModalOpen(false)}>Cancelar</Button>
              <Button onClick={handleSaveMedico} disabled={!medicoForm.nome.trim()} data-testid="btn-salvar-medico">
                {editingMedico ? 'Salvar' : 'Adicionar'}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Users Management Card (original) - Master Admin Only */}
        {isAdmin && (
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle className="flex items-center gap-2">
                    <UserCog className="h-5 w-5" />
                    Gerenciamento de Usuários
                  </CardTitle>
                  <CardDescription>
                    Crie, edite e gerencie os usuários do sistema
                  </CardDescription>
                </div>
                <Button
                  onClick={() => handleOpenUsuarioModal()}
                  className="gap-2"
                >
                  <UserPlus className="h-4 w-4" />
                  Novo Usuário
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {loadingUsuarios ? (
                <div className="flex items-center justify-center py-8">
                  <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
                </div>
              ) : usuarios.length === 0 ? (
                <div className="text-center py-8 text-muted-foreground">
                  <Users className="h-12 w-12 mx-auto mb-3 opacity-50" />
                  <p>Nenhum usuário cadastrado</p>
                  <p className="text-sm">Clique em &quot;Novo Usuário&quot; para adicionar</p>
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Nome</TableHead>
                        <TableHead>E-mail</TableHead>
                        <TableHead>Perfil</TableHead>
                        <TableHead>Status</TableHead>
                        <TableHead className="text-right">Ações</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {usuarios.map((usuario) => (
                        <TableRow key={usuario.id}>
                          <TableCell className="font-medium">{usuario.nome}</TableCell>
                          <TableCell>{usuario.email}</TableCell>
                          <TableCell>
                            <Badge variant="outline" className="capitalize">
                              {usuario.perfil?.replace('_', ' ')}
                            </Badge>
                          </TableCell>
                          <TableCell>
                            {usuario.ativo !== false ? (
                              <Badge className="bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400">
                                <CheckCircle className="h-3 w-3 mr-1" />
                                Ativo
                              </Badge>
                            ) : (
                              <Badge variant="secondary">
                                <Ban className="h-3 w-3 mr-1" />
                                Inativo
                              </Badge>
                            )}
                          </TableCell>
                          <TableCell className="text-right">
                            <div className="flex items-center justify-end gap-1">
                              {canManagePerms && (
                              <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => handleOpenPermissoesModal(usuario)}
                                title="Gerenciar Permissões"
                                data-testid={`btn-permissoes-${usuario.id}`}
                              >
                                <Shield className="h-4 w-4 text-blue-500" />
                              </Button>
                              )}
                              <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => handleOpenUsuarioModal(usuario)}
                                title="Editar"
                              >
                                <Pencil className="h-4 w-4" />
                              </Button>
                              <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => handleToggleUsuarioAtivo(usuario)}
                                title={usuario.ativo !== false ? 'Desativar' : 'Ativar'}
                              >
                                {usuario.ativo !== false ? (
                                  <Ban className="h-4 w-4 text-destructive" />
                                ) : (
                                  <CheckCircle className="h-4 w-4 text-green-600" />
                                )}
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
            </CardContent>
          </Card>
        )}

        {/* Admin: Backfill Services Card */}
        {can('editar_configuracoes') && (
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Stethoscope className="h-5 w-5" />
                Migração de Serviços Padrão
              </CardTitle>
              <CardDescription>
                Aplique os serviços padrão (ENFERMAGEM, FISIOTERAPIA, etc.) a todas as internações existentes
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <Alert>
                <AlertCircle className="h-4 w-4" />
                <AlertDescription>
                  Esta ação irá criar serviços padrão para internações que ainda não os possuem.
                  Serviços existentes <strong>não serão sobrescritos</strong>.
                </AlertDescription>
              </Alert>
              
              <div className="flex gap-3">
                <Button
                  onClick={handleOpenBackfillModal}
                  disabled={loadingBackfillPreview}
                  data-testid="btn-abrir-backfill"
                >
                  {loadingBackfillPreview ? (
                    <>
                      <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                      Carregando...
                    </>
                  ) : (
                    <>
                      <Settings className="h-4 w-4 mr-2" />
                      Aplicar serviços padrão aos pacientes existentes
                    </>
                  )}
                </Button>
              </div>
            </CardContent>
          </Card>
        )}

        {/* Password Change */}
        <ConfigSenha
          formData={formData}
          loading={loading}
          success={success}
          error={error}
          showSenhaAtual={showSenhaAtual}
          setShowSenhaAtual={setShowSenhaAtual}
          showNovaSenha={showNovaSenha}
          setShowNovaSenha={setShowNovaSenha}
          showConfirmarSenha={showConfirmarSenha}
          setShowConfirmarSenha={setShowConfirmarSenha}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          handleCancel={handleCancel}
        />

        {/* Equipe Modal */}
        <Dialog open={equipeModalOpen} onOpenChange={setEquipeModalOpen}>
          <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle>
                {editingEquipe ? 'Editar Equipe' : 'Nova Equipe'}
              </DialogTitle>
              <DialogDescription>
                {editingEquipe 
                  ? 'Atualize os dados da equipe'
                  : 'Preencha os dados para criar uma nova equipe'
                }
              </DialogDescription>
            </DialogHeader>
            
            <div className="space-y-5 py-4">
              {/* Basic Info */}
              <div className="space-y-2">
                <Label htmlFor="equipe-nome">Nome da Equipe</Label>
                <Input
                  id="equipe-nome"
                  value={equipeForm.nome}
                  onChange={(e) => setEquipeForm(prev => ({ ...prev, nome: e.target.value }))}
                  placeholder="Ex: Equipe Centro, Equipe Norte..."
                  data-testid="input-equipe-nome"
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="equipe-capacidade">Capacidade (pacientes)</Label>
                <Input
                  id="equipe-capacidade"
                  type="number"
                  min="1"
                  max="50"
                  value={equipeForm.capacidade}
                  onChange={(e) => setEquipeForm(prev => ({ 
                    ...prev, 
                    capacidade: parseInt(e.target.value) || 7 
                  }))}
                  className="w-32"
                  data-testid="input-equipe-capacidade"
                />
              </div>
              
              <div className="space-y-2">
                <Label className="flex items-center gap-2">
                  <Palette className="h-4 w-4" />
                  Cor da Equipe
                </Label>
                <div className="flex flex-wrap gap-2">
                  {colorOptions.map((color) => (
                    <button
                      key={color.value}
                      type="button"
                      className={`w-8 h-8 rounded-full border-2 transition-all ${
                        equipeForm.cor === color.value 
                          ? 'border-gray-900 dark:border-white scale-110' 
                          : 'border-transparent hover:scale-105'
                      }`}
                      style={{ backgroundColor: color.value }}
                      onClick={() => setEquipeForm(prev => ({ ...prev, cor: color.value }))}
                      title={color.name}
                    />
                  ))}
                </div>
              </div>

              <Separator />

              {/* Técnico de Enfermagem Section */}
              <div className="space-y-3">
                <h4 className="font-semibold text-sm flex items-center gap-2">
                  <Home className="h-4 w-4" />
                  Técnico de Enfermagem (para rota)
                </h4>
                <p className="text-xs text-muted-foreground">
                  Cadastre o técnico responsável por esta equipe. O endereço dele pode ser usado como ponto inicial da rota.
                </p>
                
                <div className="space-y-2">
                  <Label>Usuário do técnico (login)</Label>
                  <Select
                    value={equipeForm.tecnico_user_id || 'none'}
                    onValueChange={(v) => {
                      const u = usuarios.find(x => x.id === v);
                      setEquipeForm(prev => ({ ...prev, tecnico_user_id: v === 'none' ? '' : v, tecnico_nome: prev.tecnico_nome || (u ? u.nome : '') }));
                    }}
                  >
                    <SelectTrigger data-testid="select-tecnico-usuario"><SelectValue placeholder="Selecione o usuário" /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">Sem vínculo</SelectItem>
                      {usuarios.filter(u => (u.perfil || '').toLowerCase() === 'tecnico' && u.ativo !== false).map(u => (
                        <SelectItem key={u.id} value={u.id}>{u.nome} — {u.email}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                  <p className="text-xs text-muted-foreground">Ao entrar no Controle de Guias, este usuário verá automaticamente os pacientes desta rota do Kanban.</p>
                </div>

                <div className="space-y-2">
                  <Label htmlFor="tecnico-nome">Nome do Técnico</Label>
                  <Input
                    id="tecnico-nome"
                    value={equipeForm.tecnico_nome}
                    onChange={(e) => setEquipeForm(prev => ({ ...prev, tecnico_nome: e.target.value }))}
                    placeholder="Nome completo"
                    data-testid="input-tecnico-nome"
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="tecnico-telefone">Telefone</Label>
                  <Input
                    id="tecnico-telefone"
                    value={equipeForm.tecnico_telefone}
                    onChange={(e) => setEquipeForm(prev => ({ ...prev, tecnico_telefone: e.target.value }))}
                    placeholder="(00) 00000-0000"
                    data-testid="input-tecnico-telefone"
                  />
                </div>

                {/* CEP-based address */}
                <div className="grid grid-cols-3 gap-2">
                  <div className="space-y-1">
                    <Label htmlFor="tecnico-cep" className="text-xs">CEP</Label>
                    <div className="relative">
                      <Input
                        id="tecnico-cep"
                        value={equipeForm.tecnico_cep}
                        onChange={(e) => handleTecnicoCEP(e.target.value)}
                        placeholder="00000-000"
                        maxLength={9}
                        data-testid="input-tecnico-cep"
                      />
                      {tecnicoCepLoading && (
                        <Loader2 className="absolute right-2 top-2.5 h-4 w-4 animate-spin text-muted-foreground" />
                      )}
                    </div>
                    {tecnicoCepError && <p className="text-xs text-red-500">{tecnicoCepError}</p>}
                  </div>
                  <div className="col-span-2 space-y-1">
                    <Label htmlFor="tecnico-logradouro" className="text-xs">Logradouro</Label>
                    <Input
                      id="tecnico-logradouro"
                      value={equipeForm.tecnico_logradouro}
                      onChange={(e) => setEquipeForm(prev => ({ ...prev, tecnico_logradouro: e.target.value }))}
                      placeholder="Rua, Avenida..."
                      data-testid="input-tecnico-logradouro"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-2">
                  <div className="space-y-1">
                    <Label htmlFor="tecnico-numero" className="text-xs">Número</Label>
                    <Input
                      id="tecnico-numero"
                      value={equipeForm.tecnico_numero}
                      onChange={(e) => setEquipeForm(prev => ({ ...prev, tecnico_numero: e.target.value }))}
                      placeholder="Nº"
                      data-testid="input-tecnico-numero"
                    />
                  </div>
                  <div className="space-y-1">
                    <Label htmlFor="tecnico-bairro" className="text-xs">Bairro</Label>
                    <Input
                      id="tecnico-bairro"
                      value={equipeForm.tecnico_bairro}
                      onChange={(e) => setEquipeForm(prev => ({ ...prev, tecnico_bairro: e.target.value }))}
                      placeholder="Bairro"
                      data-testid="input-tecnico-bairro"
                    />
                  </div>
                  <div className="space-y-1">
                    <Label htmlFor="tecnico-cidade" className="text-xs">Cidade/UF</Label>
                    <div className="flex gap-1">
                      <Input
                        id="tecnico-cidade"
                        value={equipeForm.tecnico_cidade}
                        onChange={(e) => setEquipeForm(prev => ({ ...prev, tecnico_cidade: e.target.value }))}
                        placeholder="Cidade"
                        className="flex-1"
                        data-testid="input-tecnico-cidade"
                      />
                      <Input
                        value={equipeForm.tecnico_uf}
                        onChange={(e) => setEquipeForm(prev => ({ ...prev, tecnico_uf: e.target.value.toUpperCase() }))}
                        placeholder="UF"
                        maxLength={2}
                        className="w-14"
                        data-testid="input-tecnico-uf"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={handleGeocodeTecnico}
                    disabled={geocodingTecnico || (!equipeForm.tecnico_logradouro && !equipeForm.tecnico_endereco)}
                    data-testid="btn-geocode-tecnico"
                  >
                    {geocodingTecnico ? (
                      <Loader2 className="h-4 w-4 mr-1 animate-spin" />
                    ) : (
                      <LocateFixed className="h-4 w-4 mr-1" />
                    )}
                    Localizar
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => setTecnicoMapOpen(true)}
                    data-testid="btn-tecnico-mapa"
                  >
                    <MapPin className="h-4 w-4 mr-1" />
                    Mapa
                  </Button>
                  {equipeForm.tecnico_lat && equipeForm.tecnico_lng && (
                    <span className="text-xs text-green-600 flex items-center gap-1">
                      <CheckCircle className="h-3 w-3" />
                      Localizado
                    </span>
                  )}
                </div>
              </div>

              <Separator />

              {/* Ponto Inicial da Rota */}
              <div className="space-y-3">
                <h4 className="font-semibold text-sm flex items-center gap-2">
                  <Navigation2 className="h-4 w-4" />
                  Ponto Inicial da Rota
                </h4>
                <Select 
                  value={equipeForm.ponto_inicial_tipo} 
                  onValueChange={(v) => setEquipeForm(prev => ({ ...prev, ponto_inicial_tipo: v }))}
                >
                  <SelectTrigger data-testid="select-ponto-inicial">
                    <SelectValue placeholder="Selecione o ponto inicial" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="BASE">
                      <span className="flex items-center gap-2">
                        <MapPin className="h-4 w-4" /> Base Lifeport
                      </span>
                    </SelectItem>
                    <SelectItem value="TECNICO" disabled={!equipeForm.tecnico_nome}>
                      <span className="flex items-center gap-2">
                        <Home className="h-4 w-4" /> Casa do Técnico
                      </span>
                    </SelectItem>
                    <SelectItem value="PERSONALIZADO">
                      <span className="flex items-center gap-2">
                        <LocateFixed className="h-4 w-4" /> Personalizado
                      </span>
                    </SelectItem>
                  </SelectContent>
                </Select>
                <p className="text-xs text-muted-foreground">
                  {equipeForm.ponto_inicial_tipo === 'BASE' && 'A rota começará da base Lifeport.'}
                  {equipeForm.ponto_inicial_tipo === 'TECNICO' && (equipeForm.tecnico_lat 
                    ? `A rota começará da casa de ${equipeForm.tecnico_nome || 'técnico'}.`
                    : 'Defina o endereço do técnico acima para usar esta opção.'
                  )}
                  {equipeForm.ponto_inicial_tipo === 'PERSONALIZADO' && 'Um endereço personalizado será usado.'}
                </p>
              </div>

              <Separator />

              {/* Ponto Final da Rota */}
              <div className="space-y-3">
                <h4 className="font-semibold text-sm flex items-center gap-2">
                  <Navigation2 className="h-4 w-4" />
                  Ponto Final da Rota (destino)
                </h4>
                <Select 
                  value={equipeForm.ponto_final_tipo} 
                  onValueChange={(v) => setEquipeForm(prev => ({ ...prev, ponto_final_tipo: v }))}
                >
                  <SelectTrigger data-testid="select-ponto-final">
                    <SelectValue placeholder="Selecione o destino" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="BASE">
                      <span className="flex items-center gap-2">
                        <MapPin className="h-4 w-4" /> Base Lifeport
                      </span>
                    </SelectItem>
                    <SelectItem value="TECNICO" disabled={!equipeForm.tecnico_nome}>
                      <span className="flex items-center gap-2">
                        <Home className="h-4 w-4" /> Casa do Técnico
                      </span>
                    </SelectItem>
                    <SelectItem value="PERSONALIZADO">
                      <span className="flex items-center gap-2">
                        <LocateFixed className="h-4 w-4" /> Endereço personalizado
                      </span>
                    </SelectItem>
                  </SelectContent>
                </Select>
                <p className="text-xs text-muted-foreground">
                  {equipeForm.ponto_final_tipo === 'BASE' && 'A rota terminará na base Lifeport.'}
                  {equipeForm.ponto_final_tipo === 'TECNICO' && (equipeForm.tecnico_lat 
                    ? `A rota terminará na casa de ${equipeForm.tecnico_nome || 'técnico'}.`
                    : 'Defina o endereço do técnico acima para usar esta opção.'
                  )}
                  {equipeForm.ponto_final_tipo === 'PERSONALIZADO' && 'Um endereço personalizado será usado.'}
                </p>
              </div>
            </div>
            
            <DialogFooter>
              <Button
                variant="outline"
                onClick={() => setEquipeModalOpen(false)}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleSaveEquipe}
                disabled={savingEquipe || !equipeForm.nome.trim()}
                data-testid="btn-salvar-equipe"
              >
                {savingEquipe ? (
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                ) : (
                  <Save className="h-4 w-4 mr-2" />
                )}
                {editingEquipe ? 'Salvar' : 'Criar'}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Técnico Map Picker */}
        <MapPicker
          open={tecnicoMapOpen}
          onOpenChange={setTecnicoMapOpen}
          initialPosition={{
            lat: equipeForm.tecnico_lat || systemSettings.base_lat || 2.8120978,
            lng: equipeForm.tecnico_lng || systemSettings.base_lng || -60.7098542
          }}
          onSelect={handleTecnicoMapSelect}
          title={`Definir localização: ${equipeForm.tecnico_nome || 'Técnico'}`}
        />

        {/* Usuario Modal */}
        <Dialog open={usuarioModalOpen} onOpenChange={setUsuarioModalOpen}>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                {editingUsuario ? <Pencil className="h-5 w-5" /> : <UserPlus className="h-5 w-5" />}
                {editingUsuario ? 'Editar Usuário' : 'Novo Usuário'}
              </DialogTitle>
              <DialogDescription>
                {editingUsuario 
                  ? 'Atualize os dados do usuário. Deixe a senha em branco para manter a atual.'
                  : 'Preencha os dados para criar um novo usuário'
                }
              </DialogDescription>
            </DialogHeader>
            
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label htmlFor="usuario-nome" className="flex items-center gap-2">
                  <User className="h-4 w-4" />
                  Nome completo
                </Label>
                <Input
                  id="usuario-nome"
                  value={usuarioForm.nome}
                  onChange={(e) => setUsuarioForm(prev => ({ ...prev, nome: e.target.value }))}
                  placeholder="Nome do usuário"
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="usuario-email" className="flex items-center gap-2">
                  <Mail className="h-4 w-4" />
                  E-mail
                </Label>
                <Input
                  id="usuario-email"
                  type="email"
                  value={usuarioForm.email}
                  onChange={(e) => setUsuarioForm(prev => ({ ...prev, email: e.target.value }))}
                  placeholder="email@exemplo.com"
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="usuario-senha" className="flex items-center gap-2">
                  <Key className="h-4 w-4" />
                  {editingUsuario ? 'Nova senha (opcional)' : 'Senha'}
                </Label>
                <Input
                  id="usuario-senha"
                  data-testid="user-password-input"
                  autoComplete="new-password"
                  maxLength={72}
                  type="password"
                  value={usuarioForm.senha}
                  onChange={(e) => setUsuarioForm(prev => ({ ...prev, senha: e.target.value }))}
                  placeholder={editingUsuario ? 'Deixe em branco para manter' : 'Mínimo 10 caracteres'}
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="usuario-perfil" className="flex items-center gap-2">
                  <Shield className="h-4 w-4" />
                  Perfil / Nível de Acesso
                </Label>
                <Select 
                  value={usuarioForm.perfil} 
                  onValueChange={(value) => setUsuarioForm(prev => ({ ...prev, perfil: value }))}
                >
                  <SelectTrigger id="usuario-perfil">
                    <SelectValue placeholder="Selecione o perfil" />
                  </SelectTrigger>
                  <SelectContent>
                    {perfilOptions.filter(option => isMasterAdmin || option.value !== 'master_admin').map((option) => (
                      <SelectItem key={option.value} value={option.value}>
                        {option.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                <p className="text-xs text-muted-foreground">
                  O perfil define as permissões e funcionalidades disponíveis para o usuário
                </p>
                {editingUsuario?.email === PROTECTED_MASTER_ADMIN && (
                  <p className="text-xs text-amber-600 font-medium mt-1">
                    ⚠️ Este usuário é protegido e deve permanecer como Master Admin
                  </p>
                )}
              </div>
            </div>
            
            <DialogFooter>
              <Button
                variant="outline"
                onClick={() => setUsuarioModalOpen(false)}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleSaveUsuario}
                disabled={savingUsuario || !usuarioForm.nome.trim() || !usuarioForm.email.trim() || (!editingUsuario && !usuarioForm.senha)}
              >
                {savingUsuario ? (
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                ) : (
                  <Save className="h-4 w-4 mr-2" />
                )}
                {editingUsuario ? 'Salvar' : 'Criar Usuário'}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Confirm Profile Change Dialog */}
        <Dialog open={confirmPerfilChange} onOpenChange={(open) => {
          if (!open) {
            setConfirmPerfilChange(false);
            setConfirmText('');
            setPendingPerfilChange(null);
          }
        }}>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2 text-amber-600">
                <AlertCircle className="h-5 w-5" />
                Confirmação de Alteração de Perfil
              </DialogTitle>
              <DialogDescription>
                Você está alterando o perfil de um usuário para/de Master Admin.
                Esta é uma ação sensível que afeta as permissões do sistema.
              </DialogDescription>
            </DialogHeader>
            
            <div className="space-y-4 py-4">
              <div className="bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800">
                <p className="text-sm font-medium">Para confirmar, digite <strong>CONFIRMAR</strong> abaixo:</p>
              </div>
              
              <Input
                value={confirmText}
                onChange={(e) => setConfirmText(e.target.value.toUpperCase())}
                placeholder="Digite CONFIRMAR"
                className="text-center text-lg font-mono"
              />
            </div>
            
            <DialogFooter>
              <Button
                variant="outline"
                onClick={() => {
                  setConfirmPerfilChange(false);
                  setConfirmText('');
                  setPendingPerfilChange(null);
                }}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmPerfilChange}
                disabled={confirmText !== 'CONFIRMAR' || savingUsuario}
                className="bg-amber-600 hover:bg-amber-700"
              >
                {savingUsuario ? (
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                ) : null}
                Confirmar Alteração
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Permissions Modal */}
        <PermissoesModal open={showPermissoesModal} onOpenChange={setShowPermissoesModal} usuario={selectedUserForPermissoes}
          onSaved={(perms) => setUsuarios(prev => prev.map(u => u.id === selectedUserForPermissoes?.id ? { ...u, permissoes: perms, permissoes_personalizadas: true } : u))} />

        {/* Backfill Modal */}
        <Dialog open={showBackfillModal} onOpenChange={setShowBackfillModal}>
          <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <Stethoscope className="h-5 w-5" />
                Aplicar Serviços Padrão
              </DialogTitle>
              <DialogDescription>
                Esta ação criará os serviços padrão para todas as internações que ainda não os possuem.
              </DialogDescription>
            </DialogHeader>

            {backfillResult ? (
              // Show results after execution
              <div className="space-y-4 py-4">
                <Alert className={backfillResult.sucesso ? "bg-green-50 border-green-200" : "bg-red-50 border-red-200"}>
                  {backfillResult.sucesso ? (
                    <CheckCircle className="h-4 w-4 text-green-600" />
                  ) : (
                    <AlertCircle className="h-4 w-4 text-red-600" />
                  )}
                  <AlertDescription className={backfillResult.sucesso ? "text-green-800" : "text-red-800"}>
                    {backfillResult.sucesso 
                      ? "Backfill executado com sucesso!" 
                      : "Backfill concluído com alguns erros."}
                  </AlertDescription>
                </Alert>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="p-3 bg-muted rounded-lg text-center">
                    <p className="text-2xl font-bold">{backfillResult.total_internacoes}</p>
                    <p className="text-sm text-muted-foreground">Internações analisadas</p>
                  </div>
                  <div className="p-3 bg-green-50 rounded-lg text-center">
                    <p className="text-2xl font-bold text-green-600">{backfillResult.servicos_criados}</p>
                    <p className="text-sm text-green-700">Serviços criados</p>
                  </div>
                  <div className="p-3 bg-blue-50 rounded-lg text-center">
                    <p className="text-2xl font-bold text-blue-600">{backfillResult.medicacoes_criadas}</p>
                    <p className="text-sm text-blue-700">MEDICAÇÃO criados</p>
                  </div>
                  <div className="p-3 bg-gray-50 rounded-lg text-center">
                    <p className="text-2xl font-bold text-gray-600">{backfillResult.servicos_ignorados}</p>
                    <p className="text-sm text-gray-700">Já existentes</p>
                  </div>
                </div>

                {backfillResult.erros?.length > 0 && (
                  <div className="space-y-2">
                    <p className="font-medium text-red-600">Erros encontrados:</p>
                    <div className="max-h-40 overflow-y-auto bg-red-50 p-3 rounded-lg">
                      {backfillResult.erros.map((erro, i) => (
                        <p key={i} className="text-sm text-red-700">{erro}</p>
                      ))}
                    </div>
                  </div>
                )}

                <DialogFooter>
                  <Button onClick={() => setShowBackfillModal(false)}>
                    Fechar
                  </Button>
                </DialogFooter>
              </div>
            ) : (
              // Show preview before execution
              <div className="space-y-4 py-4">
                {loadingBackfillPreview ? (
                  <div className="flex items-center justify-center py-8">
                    <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
                  </div>
                ) : backfillPreview ? (
                  <>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      <div className="p-3 bg-muted rounded-lg text-center">
                        <p className="text-2xl font-bold">{backfillPreview.total_internacoes}</p>
                        <p className="text-sm text-muted-foreground">Total de internações</p>
                      </div>
                      <div className="p-3 bg-red-50 rounded-lg text-center">
                        <p className="text-2xl font-bold text-red-600">{backfillPreview.sem_servicos}</p>
                        <p className="text-sm text-red-700">Sem serviços</p>
                      </div>
                      <div className="p-3 bg-yellow-50 rounded-lg text-center">
                        <p className="text-2xl font-bold text-yellow-600">{backfillPreview.com_servicos_parciais}</p>
                        <p className="text-sm text-yellow-700">Parcialmente configurados</p>
                      </div>
                      <div className="p-3 bg-green-50 rounded-lg text-center">
                        <p className="text-2xl font-bold text-green-600">{backfillPreview.com_todos_servicos}</p>
                        <p className="text-sm text-green-700">Completos</p>
                      </div>
                    </div>

                    <div className="space-y-2">
                      <p className="font-medium">Serviços que serão criados (quando ausentes):</p>
                      <div className="flex flex-wrap gap-2">
                        {backfillPreview.servicos_padrao?.map((servico) => (
                          <Badge key={servico} variant="secondary">{servico}</Badge>
                        ))}
                      </div>
                    </div>

                    <Alert className="bg-amber-50 border-amber-200">
                      <AlertCircle className="h-4 w-4 text-amber-600" />
                      <AlertDescription className="text-amber-800">
                        <strong>Atenção:</strong> Esta ação irá modificar {backfillPreview.sem_servicos + backfillPreview.com_servicos_parciais} internações.
                        Serviços existentes não serão alterados.
                      </AlertDescription>
                    </Alert>

                    <Separator />

                    <div className="space-y-2">
                      <Label htmlFor="confirm-backfill">
                        Para confirmar, digite <strong>CONFIRMAR</strong> abaixo:
                      </Label>
                      <Input
                        id="confirm-backfill"
                        value={backfillConfirmText}
                        onChange={(e) => setBackfillConfirmText(e.target.value.toUpperCase())}
                        placeholder="CONFIRMAR"
                        className="max-w-xs"
                        data-testid="input-confirmar-backfill"
                      />
                    </div>
                  </>
                ) : null}

                <DialogFooter>
                  <Button variant="outline" onClick={() => setShowBackfillModal(false)}>
                    Cancelar
                  </Button>
                  <Button 
                    onClick={handleExecuteBackfill}
                    disabled={executingBackfill || backfillConfirmText !== 'CONFIRMAR'}
                    data-testid="btn-executar-backfill"
                  >
                    {executingBackfill ? (
                      <>
                        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                        Executando...
                      </>
                    ) : (
                      <>
                        <CheckCircle className="h-4 w-4 mr-2" />
                        Executar Backfill
                      </>
                    )}
                  </Button>
                </DialogFooter>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </Layout>
  );
};

export default Configuracoes;
